<template>
  <div id="mb-film" class="mb-film">
    <img
      v-if="startGameConfig.mainImage"
      class="main-img"
      draggable="false"
      :src="giveMeImagePlease(startGameConfig.mainImage.imagePath)"
      :style="{
        width: setMainImageValue(startGameConfig.mainImage.width, 1920) + 'px',
        height: setMainImageValue(startGameConfig.mainImage.height, 1080) + 'px',
        top: setMainImageValue(startGameConfig.mainImage.pos.y, 0) + 'px',
        left: setMainImageValue(startGameConfig.mainImage.pos.x, 0) + 'px',
      }"
    />
    <!-- <img class="mb-film-bcg" v-if="filmBcg != ''" :src="filmBcg" /> -->
    <div class="video">
      <video width="1280" height="720" id="mb-player-video" :autoplay="false" controls crossorigin style="z-index: 1">
        <source :src="filmSrc" type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      <div class="video-title">
        <span v-html="filmTitle">{{ filmTitle }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import defaultMixin from '../../mixins/defaultMixin';
import _ from 'lodash';
// import Plyr from 'plyr';
// import 'plyr/dist/plyr.css';
export default {
  name: 'mb-film',
  components: {},
  mixins: [defaultMixin],
  props: {
    startGameConfig: {
      type: Object,
      default: function () {
        return {};
      },
    },
    assets: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      filmTitle: '',
      filmSrc: '',
      filmBcg: '',
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    getPoster() {
      let poster;
      if (this.filmBcg) {
        poster = this.filmBcg;
      } else {
        poster = require(`./base.png`);
      }
      return poster;
    },
    changeFilm(_name) {
      let name = _name;
      if (!name) {
        name = _.sample(VIDEO_NAMES);
      }
      return getVideoURL(name).then((videURL) => {
        this.videoFile = videURL;
        this.forceRerender();
      });
    },
    forceRerender() {
      this.componentKey = !this.componentKey;
    },
    setMainImageValue(value, defaultValue) {
      if (value) return value;
      else return defaultValue;
    },
    init() {
      this.filmTitle = this.startGameConfig.filmTitle;
      this.filmSrc = this.giveMeImagePlease(this.startGameConfig.filmSrc);
      // this.filmBcg = this.giveMeImagePlease(this.startGameConfig.filmBcg);
      // const player = new Plyr(document.getElementById('mb-player-video'));
    },
    checkGameAction() {
      console.log('CHECK');
      return this.gameState;
    },
    resetGameAction() {},

    shuffle(a) {
      for (let i = a.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [a[i], a[j]] = [a[j], a[i]];
      }
      return a;
    },
    randomNumber(x, n) {
      return Math.floor(Math.random() * x) + n;
    },
    getRandomColor() {
      let letters = '0123456789ABCDEF';
      let color = '#';
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    },
    giveMeImagePlease(path) {
      try {
        return require(`__staticDir/${this.$store.getters.multibookType}/${path}`);
      } catch (err) {
        console.log(err);
      }
    },
  },
  beforeDestroy() {},
  computed: {
    backgroundImageUrl() {
      return 'static/' + this.startGameConfig.background;
    },
  },
};
</script>
<style lang="sass" scoped>
// @import '~pretty-checkbox/src/pretty-checkbox.scss';
@import '~@/assets/sass/variable'
@import '~@/assets/sass/iconColor'
$backgroundWidth: 1906px
$backgroundHeight: 1030px
$backgroundOffsetTop: 140px
$backgroundOffsetLeft: 0
.main-img
  position: fixed
  object-fit: cover
.mb-film
  background-size: contain
  background-repeat: no-repeat
  position: relative
  left: $backgroundOffsetLeft
  overflow: hidden
  height: 100%
  width: 100%
  top: 0px
  .mb-film-bcg
    position: absolute
    width: 100vw
    height: calc(var(--vh, 1vh) * 100)
    top: 0
    left: 0
  .video
    display: flex
    flex-direction: column
    .video-title
      padding-top: 1vmin
      padding-bottom: 1vmin
      font-size: 3vmin
      z-index: 17

#magic-button
  pointer-events: auto
  // position: absolute;
  // opacity: 1;
  // z-index: 1003;
.img-fade-leave-active, .img-fade-enter-active
  transition: all .5s linear
.img-fade-leave-to, .img-fade-enter
  opacity: 0
.img-check-fade-leave-active
  transition: all .1s .5s linear
.img-check-fade-enter-active
  transition: all .3s linear
.img-check-fade-leave-to, .img-check-fade-enter
  opacity: 0
</style>
